<!-- src/app/pages/dashboard/profile/home.page.html -->
<ion-header class="ion-no-border z-20 safe-top">
  <p-toolbar [style]="{ 'border-color': 'transparent'}">
    <ng-template #start>
      <div class="w-11">
        <button *ngIf="isViewMode" (click)="goBack()" pRipple
          class="w-10 h-10 rounded-full bg-surface-50 dark:bg-surface-800 flex items-center justify-center hover:bg-surface-100 dark:hover:bg-surface-700 transition-colors">
          <i class="pi pi-arrow-left text-surface-900 dark:text-surface-50"></i>
        </button>
      </div>
    </ng-template>
    <ng-template #center>
      Meine Kommune
    </ng-template>
    <ng-template #end>
      <div class="w-11 flex justify-end">
        <button *ngIf="!isViewMode" (click)="toSettings()" pRipple
          class="w-10 h-10 rounded-full bg-surface-50 dark:bg-surface-800 flex items-center justify-center hover:bg-surface-100 dark:hover:bg-surface-700 transition-colors">
          <i class="pi pi-cog cursor-pointer !text-xl text-surface-900 dark:text-surface-50"></i>
        </button>
      </div>
    </ng-template>
  </p-toolbar>
</ion-header>

<ion-content class="ion-no-padding home-page-content">
  <!-- Pull to Refresh -->
  <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
    <ion-refresher-content refreshingSpinner="crescent"
      pullingText="Zum Aktualisieren ziehen" refreshingText="Aktualisiere...">
    </ion-refresher-content>
  </ion-refresher>


  <div class="mx-auto  mb-24">
    <!-- Profile Header -->
    <div class="bg-white dark:bg-surface-900 border-b border-surface-200 dark:border-surface-700 p-4 mb-0">
      <!-- Loading State -->
      <div *ngIf="isLoadingProfile" class="animate-pulse">
        <div class="flex items-center gap-4 mb-4">
          <p-skeleton shape="circle" size="4rem"></p-skeleton>
          <div class="flex-1">
            <p-skeleton width="150px" height="1.25rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="100px" height="0.875rem" styleClass="mb-1"></p-skeleton>
            <p-skeleton width="80px" height="0.875rem"></p-skeleton>
          </div>
        </div>
        <div class="grid grid-cols-3 gap-3 text-center mb-4">
          <div>
            <p-skeleton height="1.25rem" styleClass="mb-1"></p-skeleton>
            <p-skeleton height="0.75rem"></p-skeleton>
          </div>
          <div>
            <p-skeleton height="1.25rem" styleClass="mb-1"></p-skeleton>
            <p-skeleton height="0.75rem"></p-skeleton>
          </div>
          <div>
            <p-skeleton height="1.25rem" styleClass="mb-1"></p-skeleton>
            <p-skeleton height="0.75rem"></p-skeleton>
          </div>
        </div>
      </div>

      <!-- Profile Content -->
      <div *ngIf="!isLoadingProfile && profile">
        <!-- Profile Info -->
        <div class="flex items-center gap-4 mb-4">
          <!-- Avatar -->
          <div class="flex-shrink-0 relative">
            <img [src]="profile.avatar || '/assets/images/default-avatar.jpg'"
              [alt]="profile.first_name + ' ' + profile.last_name"
              class="w-16 h-16 rounded-full object-cover bg-surface-200 dark:bg-surface-700 ring-2 ring-primary-500/20"
              onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'">
            <div
              class="w-16 h-16 rounded-full bg-gradient-to-br from-primary-500 to-primary-600 text-white flex items-center justify-center text-xl font-bold"
              style="display: none;">
              {{ profile.first_name?.charAt(0) || '?' }}
            </div>
          </div>

          <!-- Profile Details -->
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-2 mb-1">
              <h1 class="text-lg font-bold text-surface-900 dark:text-surface-50 truncate">
                {{ profile.first_name }} {{ profile.last_name }}
              </h1>
            </div>
            <app-user-type-badge [userType]="profile.type" [isVerified]="profile.verified"></app-user-type-badge>

            <!-- Regional Hub -->
            <div *ngIf="profile.regional_hub_name"
              class="flex items-center gap-1 text-surface-600 dark:text-surface-400 mt-2 text-xs">
              <i class="pi pi-building text-xs"></i>
              <a [routerLink]="['/dashboard/hub/', profile.regional_hub_id]"
                class="underline hover:no-underline truncate">
                {{ profile.regional_hub_name }}
              </a>
            </div>

            <!-- City -->
            <div *ngIf="profile.city" class="flex items-center gap-1 text-surface-600 dark:text-surface-400 text-xs">
              <i class="pi pi-map-marker text-xs"></i>
              <span>{{ profile.city }}</span>
            </div>
          </div>

          <!-- Follow & Notification Buttons (View Mode) -->
          <div *ngIf="isViewMode" class="flex items-center gap-2 flex-shrink-0">
            <!-- Follow Button -->
            <p-button (onClick)="toggleFollow()" [disabled]="isFollowLoading" [rounded]="true" size="small"
              [severity]="isFollowing ? 'secondary' : 'primary'" [outlined]="isFollowing" [loading]="isFollowLoading"
              styleClass="!h-9 !px-4 !text-xs !font-semibold shadow-sm">
              <ng-template pTemplate="content">
                <i [class]="isFollowing ? 'pi pi-check' : 'pi pi-user-plus'" class="mr-1.5"></i>
                <span class="hidden sm:inline">{{ isFollowing ? 'Folgt' : 'Folgen' }}</span>
              </ng-template>
            </p-button>

            <!-- Notification Button -->
            <p-button *ngIf="isFollowing" (onClick)="toggleNotifications()" [disabled]="isNotificationLoading"
              [rounded]="true" [text]="true" size="small" [severity]="notificationEnabled ? 'primary' : 'secondary'"
              [icon]="isNotificationLoading ? 'pi pi-spin pi-spinner' : (notificationEnabled ? 'pi pi-bell-fill' : 'pi pi-bell-slash')"
              styleClass="p-button-icon-only !w-9 !h-9"
              pTooltip="{{notificationEnabled ? 'Benachrichtigungen aus' : 'Benachrichtigungen an'}}"
              tooltipPosition="bottom">
            </p-button>
          </div>
        </div>

        <!-- Interests Tags -->
        <div *ngIf="profile.interests && profile.interests.length > 0" class="mb-4">
          <div class="flex flex-wrap gap-1.5">
            <p-tag *ngFor="let interest of profile.interests" [value]="interest" severity="secondary" [rounded]="true"
              styleClass="text-xs px-2 py-1">
            </p-tag>
          </div>
        </div>

        <!-- Stats -->
        <div class="grid grid-cols-3 gap-3 text-center border-t border-surface-200 dark:border-surface-700 pt-4">
          <div>
            <div class="text-xl font-bold text-surface-900 dark:text-surface-50">
              {{ profile.post_count }}
            </div>
            <div class="text-xs text-surface-600 dark:text-surface-400">
              Beiträge
            </div>
          </div>
          <div>
            <div class="text-xl font-bold text-surface-900 dark:text-surface-50">
              {{ profile.follower_count | followerCount }}
            </div>
            <div class="text-xs text-surface-600 dark:text-surface-400">
              Follower
            </div>
          </div>
          <div>
            <div class="text-xl font-bold text-surface-900 dark:text-surface-50">
              {{ profile.following_count | followerCount }}
            </div>
            <div class="text-xs text-surface-600 dark:text-surface-400">
              Gefolgt
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Energy Management Banner (nur wenn Mieter oder Stromkunde) -->
    <div *ngIf="!isViewMode && showEnergyBanner"
      class="bg-gradient-to-r from-emerald-500 via-teal-500 to-green-600 mx-4 mt-4 mb-4 rounded-2xl overflow-hidden shadow-lg cursor-pointer transform transition-all hover:scale-[1.02] active:scale-[0.98]"
      (click)="navigateToEnergy()">
      <div class="p-5 relative">
        <!-- Background Pattern -->
        <div class="absolute inset-0 opacity-10">
          <svg class="w-full h-full" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="energy-pattern" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
                <circle cx="20" cy="20" r="1.5" fill="white" />
                <path d="M 15 15 L 25 25 M 25 15 L 15 25" stroke="white" stroke-width="0.5" opacity="0.3" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#energy-pattern)" />
          </svg>
        </div>

        <!-- Content -->
        <div class="relative z-10 flex items-center justify-between">
          <div class="flex items-center gap-4">
            <div class="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
              <i class="pi pi-bolt text-white text-2xl"></i>
            </div>
            <div>
              <h3 class="text-white font-bold text-lg mb-1">Energie-Management</h3>
              <p class="text-white/90 text-sm">Verbrauch, Rechnungen & mehr</p>
            </div>
          </div>

          <div class="flex items-center gap-2">
            <div class="hidden sm:block text-right mr-3">

            </div>
            <div class="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
              <i class="pi pi-arrow-right text-white"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab Navigation -->
    <div
      class="sticky top-0 z-20 bg-white dark:bg-surface-900 border-b border-surface-200 dark:border-surface-700 overflow-hidden">
      <div class="flex overflow-x-auto scrollbar-hide">
        <button (click)="index = 0" pRipple
          class="flex-shrink-0 px-4 py-2.5 text-xs font-medium whitespace-nowrap transition-colors relative"
          [class.text-primary-600]="index === 0" [class.text-surface-600]="index !== 0">
          Posts
          <div *ngIf="index === 0" class="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-600"></div>
        </button>

        <button *ngIf="!isViewMode" (click)="index = 1" pRipple
          class="flex-shrink-0 px-4 py-2.5 text-xs font-medium whitespace-nowrap transition-colors relative"
          [class.text-primary-600]="index === 1" [class.text-surface-600]="index !== 1">
          Smart Coins
          <div *ngIf="index === 1" class="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-600"></div>
        </button>

        <button (click)="index = 2" *ngIf="!isViewMode" pRipple
          class="flex-shrink-0 px-4 py-2.5 text-xs font-medium whitespace-nowrap transition-colors relative"
          [class.text-primary-600]="index === 2" [class.text-surface-600]="index !== 2">
          Bestellungen
          <div *ngIf="index === 2" class="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-600"></div>
        </button>

        <button (click)="index = 3" *ngIf="!isViewMode" pRipple
          class="flex-shrink-0 px-4 py-2.5 text-xs font-medium whitespace-nowrap transition-colors relative"
          [class.text-primary-600]="index === 3" [class.text-surface-600]="index !== 3">
          Tickets
          <div *ngIf="index === 3" class="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-600"></div>
        </button>
      </div>
    </div>

    <!-- Tab Content -->
    <div class="max-w-4xl mx-auto">
      <!-- Posts Tab -->
      <div *ngIf="index === 0" class="py-2">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 px-2">
          <app-feed-card *ngFor="let post of posts" [post]="post" [currentUserId]="currentUserId"
            (commentsOpened)="openCommentsSheet($event)" (authorClicked)="viewAccount($event)"
            (shareClicked)="openShareSheet($event)" (reportClicked)="reportPost($event)"
            (pollResultsOpened)="onPollResultsOpened($event)" class="rounded-lg overflow-hidden shadow-sm">
          </app-feed-card>
        </div>

        <!-- Empty State -->
        <div *ngIf="!isLoadingPosts && posts.length === 0" class="p-8 text-center">
          <div
            class="bg-surface-100 dark:bg-surface-800 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
            <i class="pi pi-image text-2xl text-surface-400"></i>
          </div>
          <h3 class="text-base font-semibold text-surface-900 dark:text-surface-50 mb-1">
            Noch keine Beiträge
          </h3>
          <p class="text-xs text-surface-600 dark:text-surface-400">
            {{ profile?.first_name || 'Dieser Nutzer' }} hat noch keine Beiträge veröffentlicht.
          </p>
        </div>
      </div>

      <!-- Smart Coins Tab -->
      <div *ngIf="index === 1" class="p-4 space-y-3">
        <!-- Balance Card - Enhanced with Green -->
        <div
          class="relative bg-gradient-to-br from-[#f0f8f0] to-[#dcefdc] dark:from-[#0a3e0f] dark:to-[#0d4f13] rounded-lg p-5 border border-[#b8dfb8]/30 dark:border-[#1b5e20] overflow-hidden">
          <!-- Subtle background pattern -->
          <div class="absolute top-0 right-0 w-32 h-32 opacity-[0.04] dark:opacity-[0.08]">
            <svg viewBox="0 0 100 100" class="w-full h-full">
              <circle cx="50" cy="50" r="40" fill="currentColor" class="text-[#2e7d32]" />
            </svg>
          </div>

          <div class="relative">
            <div class="flex items-center gap-2 mb-1">
              <div class="w-8 h-8 rounded-lg bg-[#2e7d32] dark:bg-[#66bd66] flex items-center justify-center shadow-sm">
                <i class="pi pi-star-fill text-white text-sm"></i>
              </div>
              <span class="text-xs font-medium text-[#1b5e20] dark:text-[#b8dfb8]">Dein Guthaben</span>
            </div>

            <div class="flex items-baseline gap-2 mb-5 mt-2">
              <h2 class="text-5xl font-bold text-[#0d4f13] dark:text-[#dcefdc]">{{ totalCoins | number }}</h2>
              <span class="text-lg font-medium text-[#2e7d32] dark:text-[#8fce8f]">SC</span>
            </div>

            <div class="grid grid-cols-2 gap-3">
              <div
                class="bg-white/60 dark:bg-[#07270a]/40 backdrop-blur-sm rounded-md p-3 border border-[#b8dfb8]/40 dark:border-[#1b5e20]/50">
                <div class="flex items-center gap-1.5 mb-1">
                  <div class="w-1.5 h-1.5 rounded-full bg-[#66bd66]"></div>
                  <span class="text-xs text-[#1b5e20] dark:text-[#b8dfb8]">Verdient</span>
                </div>
                <p class="text-xl font-semibold text-[#0d4f13] dark:text-[#dcefdc]">+{{ monthlyEarned }}</p>
              </div>
              <div
                class="bg-white/60 dark:bg-[#07270a]/40 backdrop-blur-sm rounded-md p-3 border border-[#b8dfb8]/40 dark:border-[#1b5e20]/50">
                <div class="flex items-center gap-1.5 mb-1">
                  <div class="w-1.5 h-1.5 rounded-full bg-[#8fce8f] dark:bg-[#66bd66]"></div>
                  <span class="text-xs text-[#1b5e20] dark:text-[#b8dfb8]">Ausgegeben</span>
                </div>
                <p class="text-xl font-semibold text-[#0d4f13] dark:text-[#dcefdc]">{{ monthlySpent }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Badges Section -->
        <div *ngIf="inProgressBadges.length > 0 || achievedBadges.length > 0"
          class="bg-white dark:bg-surface-900 rounded-lg border border-surface-200 dark:border-surface-800 p-4">
          <div class="flex items-center justify-between mb-3">
            <h3 class="text-sm font-medium text-surface-900 dark:text-surface-50">
              Badges
            </h3>
            <button (click)="openBadgesSheet()" pRipple
              class="text-xs text-surface-500 dark:text-surface-400 hover:text-surface-900 dark:hover:text-surface-50">
              Alle →
            </button>
          </div>

          <!-- Loading State -->
          <div *ngIf="isLoadingBadges" class="space-y-2">
            <div *ngFor="let i of [1,2,3]" class="flex items-center gap-2.5 p-2">
              <p-skeleton shape="circle" size="2.5rem"></p-skeleton>
              <div class="flex-1">
                <p-skeleton width="60%" height="0.875rem" styleClass="mb-1.5"></p-skeleton>
                <p-skeleton width="100%" height="0.375rem"></p-skeleton>
              </div>
            </div>
          </div>

          <!-- In Progress Badges -->
          <div *ngIf="!isLoadingBadges && inProgressBadges.length > 0" class="space-y-1.5 mb-3">
            <div *ngFor="let badge of topBadges"
              class="flex items-center gap-2.5 p-2.5 rounded-md hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors cursor-pointer"
              (click)="viewBusinessHub(badge.businessHubId!.toString())">

              <!-- Icon -->
              <div
                class="w-9 h-9 rounded-md flex items-center justify-center flex-shrink-0 bg-surface-50 dark:bg-surface-800 border border-surface-200 dark:border-surface-700">
                <i [class]="'pi ' + badge.config.badgeIcon + ' text-sm text-surface-600 dark:text-surface-400'"></i>
              </div>

              <!-- Info -->
              <div class="flex-1 min-w-0">
                <p class="text-sm font-medium text-surface-900 dark:text-surface-50 mb-1.5">
                  {{ badge.config.badgeName }}
                </p>

                <!-- Progress Bar -->
                <div class="flex items-center gap-2">
                  <p-progressBar [value]="badge.progressPercentage" [showValue]="false" styleClass="h-1 flex-1" />
                  <span class="text-xs text-surface-500 dark:text-surface-400 flex-shrink-0">
                    {{ badge.currentProgress }}/{{ badge.config.requiredAmount }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Achieved Badges -->
          <div *ngIf="!isLoadingBadges && achievedBadges.length > 0">
            <div class="flex items-center gap-1.5 mb-2 pt-2 border-t border-surface-200 dark:border-surface-800">
              <span class="text-xs text-surface-500 dark:text-surface-400">Abgeschlossen · {{ achievedBadges.length
                }}</span>
            </div>

            <div class="space-y-1.5">
              <div *ngFor="let badge of achievedBadges.slice(0, 3)"
                class="flex items-center gap-2.5 p-2.5 rounded-md hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors cursor-pointer"
                (click)="viewBusinessHub(badge.businessHubId!.toString())">

                <!-- Icon -->
                <div
                  class="w-9 h-9 rounded-md flex items-center justify-center flex-shrink-0 bg-surface-50 dark:bg-surface-800 border border-surface-200 dark:border-surface-700">
                  <i [class]="'pi ' + badge.config.badgeIcon + ' text-sm text-surface-600 dark:text-surface-400'"></i>
                </div>

                <!-- Info -->
                <div class="flex-1 min-w-0">
                  <p class="text-sm font-medium text-surface-900 dark:text-surface-50">
                    {{ badge.config.badgeName }}
                  </p>
                  <p class="text-xs text-surface-500 dark:text-surface-400">Abgeschlossen</p>
                </div>
              </div>
            </div>

            <!-- Show More if there are more than 3 -->
            <button *ngIf="achievedBadges.length > 3" (click)="openBadgesSheet()" pRipple
              class="w-full mt-2 py-1.5 text-xs text-surface-500 dark:text-surface-400 hover:bg-surface-50 dark:hover:bg-surface-800 rounded-md transition-colors">
              + {{ achievedBadges.length - 3 }} weitere
            </button>
          </div>

          <!-- Empty State -->
          <div *ngIf="!isLoadingBadges && inProgressBadges.length === 0 && achievedBadges.length === 0"
            class="py-6 text-center">
            <div
              class="w-12 h-12 mx-auto mb-2 rounded-md bg-surface-50 dark:bg-surface-800 flex items-center justify-center">
              <i class="pi pi-trophy text-lg text-surface-400"></i>
            </div>
            <p class="text-xs text-surface-500 dark:text-surface-400">
              Noch keine Badges verdient
            </p>
          </div>
        </div>

        <!-- Donations Card -->
        <div *ngIf="donationStats"
          class="bg-white dark:bg-surface-900 rounded-lg border border-surface-200 dark:border-surface-800 p-4">
          <h3 class="text-sm font-medium text-surface-900 dark:text-surface-50 mb-3">
            Spenden · {{ donationStats.regionalHubName }}
          </h3>

          <!-- Stats Grid -->
          <div class="grid grid-cols-2 gap-3 mb-4">
            <div class="space-y-1">
              <span class="text-xs text-surface-500 dark:text-surface-400">Gesamt</span>
              <p class="text-lg font-semibold text-surface-900 dark:text-surface-50">
                {{ donationStats.totalDonated }}
              </p>
              <p class="text-xs text-surface-500 dark:text-surface-400">
                {{ donationStats.donorCount }} Spender
              </p>
            </div>

            <div class="space-y-1">
              <span class="text-xs text-surface-500 dark:text-surface-400">Meine</span>
              <p class="text-lg font-semibold text-surface-900 dark:text-surface-50">
                {{ donationStats.myDonations }}
              </p>
              <p class="text-xs text-surface-500 dark:text-surface-400">Smart Coins</p>
            </div>
          </div>

          <!-- Donate Button -->
          <p-button label="Spenden" (onClick)="openDonationSheet()" icon="pi pi-heart" styleClass="w-full" size="small"
            [outlined]="true">
          </p-button>
        </div>

        <!-- Top Sources -->
        <div class="bg-white dark:bg-surface-900 rounded-lg border border-surface-200 dark:border-surface-800 p-4">
          <h3 class="text-sm font-medium text-surface-900 dark:text-surface-50 mb-3">
            Top Quellen
          </h3>
          <div class="space-y-2">
            <div *ngFor="let source of getTopCoinSources()"
              class="flex items-center gap-2.5 cursor-pointer hover:bg-surface-50 dark:hover:bg-surface-800 p-2 rounded-md transition-colors"
              (click)="viewBusinessHub(source.businessHubId.toString())">
              <div
                class="w-9 h-9 rounded-md bg-surface-50 dark:bg-surface-800 border border-surface-200 dark:border-surface-700 flex items-center justify-center flex-shrink-0">
                <i [class]="'pi ' + source.icon + ' text-sm text-surface-600 dark:text-surface-400'"></i>
              </div>
              <div class="flex-1 min-w-0">
                <div class="flex items-center justify-between mb-1.5">
                  <span class="text-sm font-medium text-surface-900 dark:text-surface-50 truncate">
                    {{ source.category }}
                  </span>
                  <span class="text-sm font-medium text-surface-900 dark:text-surface-50">
                    {{ source.amount }}
                  </span>
                </div>
                <p-progressBar [value]="source.percentage" [showValue]="false" styleClass="h-1" />
              </div>
            </div>
          </div>
        </div>

        <!-- Recent Transactions -->
        <div class="bg-white dark:bg-surface-900 rounded-lg border border-surface-200 dark:border-surface-800 p-4">
          <div class="flex items-center justify-between mb-3">
            <h3 class="text-sm font-medium text-surface-900 dark:text-surface-50">
              Aktivitäten
            </h3>
            <button (click)="openTransactionsSheet()" pRipple
              class="text-xs text-surface-500 dark:text-surface-400 hover:text-surface-900 dark:hover:text-surface-50">
              Alle →
            </button>
          </div>

          <div class="space-y-1">
            <div *ngFor="let transaction of coinTransactions"
              class="flex items-center gap-2.5 p-2.5 rounded-md hover:bg-surface-50 dark:hover:bg-surface-800 transition-colors cursor-pointer"
              (click)="viewBusinessHub(transaction.businessHubId)">

              <div
                class="w-9 h-9 rounded-md flex items-center justify-center flex-shrink-0 bg-surface-50 dark:bg-surface-800 border border-surface-200 dark:border-surface-700">
                <img *ngIf="transaction.businessAvatar" [src]="transaction.businessAvatar"
                  [alt]="transaction.businessName" class="w-full h-full rounded-md object-cover"
                  onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'">
                <i [class]="'pi ' + transaction.icon + ' text-sm text-surface-600 dark:text-surface-400'"
                  [style.display]="transaction.businessAvatar ? 'none' : 'flex'"></i>
              </div>

              <div class="flex-1 min-w-0">
                <p class="text-sm font-medium text-surface-900 dark:text-surface-50 truncate">
                  {{ transaction.description }}
                </p>
                <p class="text-xs text-surface-500 dark:text-surface-400">
                  {{ formatTimestamp(transaction.date.toString()) }}
                </p>
              </div>

              <div class="text-right flex-shrink-0">
                <p class="text-sm font-medium" [ngClass]="{
              'text-green-600 dark:text-green-500': transaction.type === 'verdient',
              'text-surface-900 dark:text-surface-50': transaction.type === 'ausgegeben'
            }">
                  {{ transaction.type === 'verdient' ? '+' : '-' }}{{ transaction.amount }}
                </p>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div *ngIf="coinTransactions.length === 0" class="py-6 text-center">
            <div
              class="w-12 h-12 mx-auto mb-2 rounded-md bg-surface-50 dark:bg-surface-800 flex items-center justify-center">
              <i class="pi pi-inbox text-lg text-surface-400"></i>
            </div>
            <p class="text-xs text-surface-500 dark:text-surface-400">
              Noch keine Transaktionen
            </p>
          </div>
        </div>
      </div>

      <!-- Bestellungen Tab -->
      <div *ngIf="index === 2" class="p-3 space-y-3">
        <app-orders-list></app-orders-list>
      </div>

      <!-- Tickets Tab -->
      <div *ngIf="index === 3" class="p-3 space-y-3">
        <app-tickets-list></app-tickets-list>
      </div>
    </div>
  </div>

  <ion-infinite-scroll *ngIf="index === 0" (ionInfinite)="onIonInfinite($event)" [disabled]="stopPostsPagination">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>

  <app-comments-sheet [post]="selectedPost" [visible]="commentsSheetVisible" (onClose)="closeCommentsSheet()"
    (onCommentsUpdated)="onCommentsUpdated($event)">
  </app-comments-sheet>

  <!-- Share Modal -->
  <ion-modal #shareModal [isOpen]="shareSheetVisible" [initialBreakpoint]="0.5" [breakpoints]="[0, 0.5, 0.75]"
    class="share-modal" [backdropBreakpoint]="0.2" (didDismiss)="closeShareSheet()">
    <ng-template>
      <app-share-sheet [post]="postToShare" [visible]="shareSheetVisible" (onClose)="closeShareSheet()">
      </app-share-sheet>
    </ng-template>
  </ion-modal>

  <!-- NEW: Transactions Modal -->
  <ion-modal #transactionsModal [isOpen]="transactionsSheetVisible" [initialBreakpoint]="0.4"
    [breakpoints]="[0, 0.4, 0.75, 1]" class="transactions-modal" [backdropBreakpoint]="0.2"
    (didDismiss)="closeTransactionsSheet()">
    <ng-template>
      <app-transactions-sheet (onClose)="closeTransactionsSheet()"></app-transactions-sheet>
    </ng-template>
  </ion-modal>

  <!-- Donation Modal -->
  <ion-modal #donationModal [isOpen]="donationSheetVisible" [initialBreakpoint]="0.75" [breakpoints]="[0, 0.75, 0.95]"
    class="donation-modal" [backdropBreakpoint]="0.2" (didDismiss)="closeDonationSheet()">
    <ng-template>
      <app-donation-sheet [visible]="donationSheetVisible" (onClose)="closeDonationSheet()"
        (onDonationSuccess)="onDonationSuccess()">
      </app-donation-sheet>
    </ng-template>
  </ion-modal>

  <!-- Badges Modal -->
  <ion-modal #badgesModal [isOpen]="badgesSheetVisible" [initialBreakpoint]="0.6" [breakpoints]="[0, 0.6, 0.9]"
    class="badges-modal" [backdropBreakpoint]="0.2" (didDismiss)="closeBadgesSheet()">
    <ng-template>
      <app-badges-sheet [visible]="badgesSheetVisible" [badges]="badges" [isLoading]="isLoadingBadges"
        (onClose)="closeBadgesSheet()">
      </app-badges-sheet>
    </ng-template>
  </ion-modal>


</ion-content>

<div class="fab-container">
  <p-button icon="pi pi-camera" (click)="scannerDialogVisible= true" [rounded]="true" severity="primary"
    styleClass="w-14 h-14 shadow-lg transition-shadow fab-button hover:shadow-xl" />
</div>
<!-- Scanner Modal -->
<ion-modal [isOpen]="scannerDialogVisible" [initialBreakpoint]="0.85" [breakpoints]="[0, 0.85, 1]" class="scanner-modal"
  [backdropDismiss]="!isAnalysisInProgress" [canDismiss]="!isAnalysisInProgress"
  (didDismiss)="!isAnalysisInProgress && (scannerDialogVisible = false)">
  <ng-template>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-title>
          <div class="flex items-center gap-3">
            <i class="pi pi-camera text-primary-600 text-xl"></i>
            <span class="text-lg font-semibold">Rechnung scannen</span>
          </div>
        </ion-title>
        <ion-buttons slot="end" *ngIf="!isAnalysisInProgress">
          <ion-button (click)="scannerDialogVisible = false">
            <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding scanner-content">
      <!-- Processing Status -->
      <div *ngIf="isAnalysisInProgress && !errorMessage && !processedInvoice" class="py-6 px-4">
        <div class="relative max-w-md mx-auto">
          <!-- Scanned Image Preview -->
          <div class="relative overflow-hidden rounded-2xl shadow-lg bg-white dark:bg-surface-800">
            <img *ngIf="scannedImageDataUrl" [src]="scannedImageDataUrl" alt="Scanned Invoice"
              class="w-full h-auto min-h-[200px] max-h-[300px] object-contain" />

            <!-- Scanning Animation Overlay -->
            <div class="absolute inset-0 pointer-events-none">
              <!-- Animated scanning line -->
              <div
                class="absolute left-0 right-0 h-1 bg-gradient-to-r from-transparent via-primary-500 to-transparent opacity-80 animate-scan-line shadow-lg">
              </div>

              <!-- Corner indicators -->
              <div class="absolute top-4 left-4 w-8 h-8 border-t-4 border-l-4 border-primary-500 rounded-tl-lg"></div>
              <div class="absolute top-4 right-4 w-8 h-8 border-t-4 border-r-4 border-primary-500 rounded-tr-lg"></div>
              <div class="absolute bottom-4 left-4 w-8 h-8 border-b-4 border-l-4 border-primary-500 rounded-bl-lg">
              </div>
              <div class="absolute bottom-4 right-4 w-8 h-8 border-b-4 border-r-4 border-primary-500 rounded-br-lg">
              </div>

              <!-- Pulse overlay -->
              <div class="absolute inset-0 bg-primary-500/5 animate-pulse"></div>
            </div>
          </div>

          <!-- Status Text -->
          <div class="mt-6 text-center">
            <div class="flex items-center justify-center gap-3 mb-3">
              <div class="w-2 h-2 bg-primary-600 rounded-full animate-ping"></div>
              <div class="w-2 h-2 bg-primary-600 rounded-full animate-ping" style="animation-delay: 0.2s"></div>
              <div class="w-2 h-2 bg-primary-600 rounded-full animate-ping" style="animation-delay: 0.4s"></div>
            </div>
            <p class="text-lg font-semibold text-surface-900 dark:text-surface-50 mb-2">
              {{ processingStatus }}
            </p>
            <p class="text-sm text-surface-600 dark:text-surface-400">
              Dies kann einen Moment dauern...
            </p>
          </div>
        </div>
      </div>

      <!-- Success State -->
      <div *ngIf="processedInvoice" class="relative text-center py-6 px-4 overflow-hidden">
        <!-- Background Glow -->
        <div
          class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-green-500/10 dark:bg-green-400/10 rounded-full blur-3xl">
        </div>

        <!-- Success Icon -->
        <div class="flex justify-center mb-4 relative z-10">
          <div class="relative">
            <div
              class="w-16 h-16 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center shadow-lg">
              <i class="pi pi-check text-3xl text-white"></i>
            </div>
          </div>
        </div>

        <!-- Title -->
        <h3 class="text-xl font-bold text-surface-900 dark:text-surface-50 mb-1 relative z-10">
          Erfolgreich! 🎉
        </h3>
        <p class="text-sm text-surface-600 dark:text-surface-400 mb-6 relative z-10">
          Deine Rechnung wurde verarbeitet
        </p>

        <!-- Coins Earned -->
        <div class="relative z-10 mb-6">
          <div
            class="inline-block bg-gradient-to-br from-primary-500 to-primary-600 dark:from-primary-600 dark:to-primary-700 rounded-2xl px-6 py-5 shadow-lg">
            <div class="flex items-center gap-3">
              <div class="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
                <i class="pi pi-star-fill text-white text-2xl"></i>
              </div>
              <div class="text-left">
                <p class="text-primary-100 text-xs font-medium mb-0.5">Du hast verdient</p>
                <div class="flex items-baseline gap-2">
                  <p class="text-white text-3xl font-bold">+{{ processedInvoice.xpAwarded }}</p>
                  <p class="text-primary-100 text-sm font-semibold">SC</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Invoice Details Card -->
        <div
          class="bg-white dark:bg-surface-900 rounded-xl border border-surface-200 dark:border-surface-700 p-4 mb-6 text-left max-w-sm mx-auto shadow-sm relative z-10">
          <div class="flex items-center gap-2 mb-3 pb-3 border-b border-surface-200 dark:border-surface-700">
            <div class="w-7 h-7 rounded-lg bg-primary-50 dark:bg-primary-900/20 flex items-center justify-center">
              <i class="pi pi-file text-primary-600 dark:text-primary-400 text-sm"></i>
            </div>
            <h4 class="text-sm font-semibold text-surface-900 dark:text-surface-50">Rechnungsdetails</h4>
          </div>

          <div class="space-y-2.5">
            <!-- Company -->
            <div
              class="bg-primary-50 dark:bg-primary-900/20 rounded-lg p-3 border border-primary-200 dark:border-primary-800">
              <div class="flex items-center gap-2.5">
                <div
                  class="w-8 h-8 rounded-full bg-primary-600 dark:bg-primary-500 flex items-center justify-center flex-shrink-0">
                  <i class="pi pi-building text-white text-sm"></i>
                </div>
                <div class="flex-1 min-w-0">
                  <p class="text-[10px] font-medium text-primary-700 dark:text-primary-300 mb-0.5">Partner</p>
                  <p class="text-sm font-bold text-primary-900 dark:text-primary-100 truncate">
                    {{ processedInvoice.companyName || 'Unbekannt' }}
                  </p>
                </div>
                <i class="pi pi-check-circle text-green-600 text-lg"></i>
              </div>
            </div>

            <!-- Amount -->
            <div class="flex justify-between items-center py-1">
              <span class="text-xs text-surface-600 dark:text-surface-400">Betrag</span>
              <span class="text-sm font-bold text-surface-900 dark:text-surface-50">{{ processedInvoice.totalAmount |
                currency:'EUR':'symbol':'1.2-2':'de' }}</span>
            </div>

            <!-- Tax ID -->
            <div class="flex justify-between items-center py-1">
              <span class="text-xs text-surface-600 dark:text-surface-400">USt-IdNr.</span>
              <span class="text-xs font-mono text-surface-900 dark:text-surface-50">{{ processedInvoice.taxId }}</span>
            </div>

            <!-- Date -->
            <div *ngIf="processedInvoice.invoiceDate" class="flex justify-between items-center py-1">
              <span class="text-xs text-surface-600 dark:text-surface-400">Datum</span>
              <span class="text-xs text-surface-900 dark:text-surface-50">{{ processedInvoice.invoiceDate }}</span>
            </div>
          </div>
        </div>

        <!-- Redirect Message -->
        <div class="flex items-center justify-center gap-2 text-surface-500 dark:text-surface-400 relative z-10">
          <div class="w-3 h-3 border-2 border-primary-600 border-t-transparent rounded-full animate-spin"></div>
          <p class="text-xs">Wird geschlossen...</p>
        </div>
      </div>

      <!-- Error State -->
      <div *ngIf="errorMessage && !isAnalysisInProgress" class="text-center py-6">
        <div class="flex justify-center mb-4">
          <div class="w-14 h-14 bg-red-100 dark:bg-red-900 rounded-full flex items-center justify-center">
            <i class="pi pi-times text-2xl text-red-600 dark:text-red-400"></i>
          </div>
        </div>
        <h3 class="text-lg font-bold text-surface-900 dark:text-surface-50 mb-2">
          Fehler bei der Verarbeitung
        </h3>
        <p class="text-sm text-surface-600 dark:text-surface-400 mb-4">
          {{ errorMessage }}
        </p>
        <p-button label="Erneut versuchen" icon="pi pi-refresh" (onClick)="resetScanner(); startScan()"
          size="small"></p-button>
      </div>

      <!-- Initial State -->
      <div *ngIf="!scannedImage && !isAnalysisInProgress && !errorMessage" class="text-center py-6">
        <div class="flex justify-center mb-4">
          <div class="w-20 h-20 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center">
            <i class="pi pi-camera text-3xl text-blue-600 dark:text-blue-400"></i>
          </div>
        </div>
        <h3 class="text-lg font-bold text-surface-900 dark:text-surface-50 mb-2">
          Bereit zum Scannen
        </h3>
        <p class="text-sm text-surface-600 dark:text-surface-400 mb-4">
          Scanne deine Rechnung, um automatisch Smart Coins zu verdienen.<br>
          
        </p>
        <p-button label="Rechnung scannen" icon="pi pi-camera" (onClick)="startScan()"></p-button>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
<app-poll-results-sheet [post]="selectedPollPost" [visible]="pollResultsSheetVisible" [isCreator]="isPollCreator"
  (onClose)="closePollResultsSheet()">
</app-poll-results-sheet>
<!-- Post Menu -->
<p-menu #postMenu [model]="postMenuItems" [popup]="true" />